import { SourceItem } from "../../../shared/models/source-item.model";
import { FileService } from "./file.service";
import { Metadata, PropertiesModel } from "../../../shared/models/metadata.model";
import { getPathToRoot } from "../../../shared/utils/link.utils";

/***
 * This is the local backend implementation that uses the downloaded metadata to get data.
 */
export class FileServiceLocal implements FileService {
    currentPath: string = "/";
    constructor(currentPath: string) {
        this.currentPath = currentPath;
    }
    public getTextfile = async (
        _url: string,
    ): Promise<string> => {
        // This method should not get called in local mode, it is not possible to read
        // files from the local filesystem using JS
        return "";
    }

    public getIdLink = (
        _id: string,
    ) => {
        // This method is only for the admin app and should not be used in local mode
        return "";
    }

    public getDirectLink = (
        _site: string,
        path: string,
        _validity: string,
        _systemProperties: PropertiesModel,
        _lang: string,
        _requestItem?: "content" | "metadata" | "markdown",
    ): string => {
        return getPathToRoot(this.currentPath) + path.startsWith("/") ? path.substring(1) : path;
    }

    public getMarkdownExistsUrl = (
        _site: string,
        _path: string,
        _validity: string,
        _systemProperties: PropertiesModel,
    ): string => {
        return "";
    }

    public getDownloadLink = (
        _site: string,
        _items: Array<SourceItem>,
    ): string => {
        // Local downloads should not use download links
        return "";
    }

    public getMetadata = async (
        _id: string,
    ): Promise<Metadata | null> => {
        return Promise.resolve(null);
    }

    public getMetadataByUrl = async (
        _url: string,
    ): Promise<Metadata | null> => {
        return Promise.resolve(null);
    }

    public getMetadataByToken = async (
        _site: string,
        _token: string,
    ): Promise<Array<Metadata> | null> => {
        // Local mode does not support tokens
        return Promise.resolve(null);
    }

    public existsByPaths = async (
        _site: string,
        paths: string[],
        _validity: string,
        _lang: string,
    ): Promise<string[]> => {
        // Offline / downloaded files: fail open (treat requested paths as existing).
        return Promise.resolve([...paths]);
    }
}
